import { render, staticRenderFns } from "./TitleListGrid.vue?vue&type=template&id=b6465afa"
import script from "./TitleListGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleListGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleListGrid.vue?vue&type=style&index=0&id=b6465afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports